export const createVersionRequests = (client) => ({
    getApiVersion: async (params = {}) => {
        // Rendered on the login and password-reset screens, so it deliberately goes
        // through the unauthenticated client: a stale token in localStorage must not
        // be able to 401 here and kick the user off a public screen.
        const data = await client.publicApi.request({
            type: "version",
            method: "GET",
            url: "/version",
            params: params,
        });
        return data;
    },
});
//# sourceMappingURL=index.js.map